import { useEffect } from 'react';
import { eventBus } from './event-bus';

export function useEventBus<T = unknown>(
  event: string,
  handler: (payload: T) => void
): void {
  useEffect(() => {
    const unsubscribe = eventBus.on(event, handler);
    return unsubscribe;
  }, [event, handler]);
}
